/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_ResourcesInputs */

const en_mk_foot_resources = /** @type {(inputs: Mk_Foot_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const id_mk_foot_resources = /** @type {(inputs: Mk_Foot_ResourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumber daya`)
};

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Mk_Foot_ResourcesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_resources = /** @type {((inputs?: Mk_Foot_ResourcesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_ResourcesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_resources(inputs)
	return en_mk_foot_resources(inputs)
});